import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=4bc1e938&scoped=true&"
import script from "./UserSelect.vue?vue&type=script&lang=ts&"
export * from "./UserSelect.vue?vue&type=script&lang=ts&"
import style0 from "./UserSelect.vue?vue&type=style&index=0&id=4bc1e938&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1e938",
  null
  
)

export default component.exports